/** @flow */
import moment from 'moment';
import * as React from 'react';
import { translate } from 'react-i18next';
import { TooltipWrapper, TooltipTitle, TooltipItemList, TooltipItem } from '../../../components/charts/tooltip/RechartsToolTipStyles';
import { displayNumber } from '../../../components/Number';
import type { MetricByDate } from '../domain/CampaignMetrics';

type TooltipProps = {
  active?: boolean;
  label?: string;
  entryValueLabel?: string;
  payload?: Array<Object>;
  data?: MetricByDate;
  t: any;
}

function CampaignMetricByDayTooltip({ active, payload, label, entryValueLabel, data, t }: TooltipProps) {
  if (active && payload) {
    const unixLabel = moment(label, t('dateFormat.standard')).unix();
    const nbSpots = data && unixLabel ? data[unixLabel] : 0;
    const showSpots = Boolean(data);

    const items = payload
      .filter(entry => entry.value)
      .filter(entry => entry.name !== 'disabledAt')
      .map((entry, i) => {
        return (
          <TooltipItemList key={`tooltip-item-${entry.dataKey}`}>
            <TooltipItem color={entry.color}>{entryValueLabel} : {displayNumber(entry.value)}</TooltipItem>
            {showSpots && <TooltipItem color={entry.color}>{t('spotsTitle')} : {displayNumber(nbSpots)}</TooltipItem>}
          </TooltipItemList>
        );
      });

    return (
      <TooltipWrapper>
        <TooltipTitle>{label}</TooltipTitle>
        <TooltipItemList>{items}</TooltipItemList>
      </TooltipWrapper>
    );
  }
  return null;
}

export default translate()(CampaignMetricByDayTooltip);



// WEBPACK FOOTER //
// ./src/common/modules/campaign/components/CampaignMetricByDayTooltip.js